module.exports = __webpack_public_path__ + "img/icon_estate-management.bbc879d0.svg";